<template>
  <div>
      <h1>Games List</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>